import { observable, action } from 'mobx';
import moment from 'moment';
import ApiCaller from '../../utils/api-caller';

class bookTaxiStore {

    // PROPERTIES

    @observable destination = '';
    @observable noOfPerson = 1;

    @observable minDate = undefined;
    @observable dateDeliver = '';
    @observable dateDeliverDate = undefined;
    @observable timeDeliver = '';
    @observable timeDeliverDate = undefined;

    @observable fromOptions = [
        { label: 'My villa', value: 'My villa'},
        { label: 'Reception', value: 'Reception'},
        { label: 'Wellness Pavilion', value: 'Wellness Pavilion'},
        { label: 'Market restaurant', value: 'Market restaurant'},
        { label: 'Devarana Spa', value: 'Devarana Spa'},
        { label: 'Seagrill restaurant', value: 'Seagrill restaurant'},
        { label: 'Sandbar', value: 'Sandbar'},
        { label: 'Benjarong restaurant', value: 'Benjarong restaurant'},
        { label: 'Sala Bar', value: 'Sala Bar'},
        { label: 'Tennis court', value: 'Tennis court'},
        { label: 'Dive Center', value: 'Dive Center'},
        { label: 'Activity Center', value: 'Activity Center'},
        { label: 'Gym', value: 'Gym'},
        { label: 'Kids Club', value: 'Kids Club'},
        { label: 'Clinic', value: 'Clinic'},
        { label: 'Boutique Shop', value: 'Boutique Shop'},
        { label: 'Other', value: 'Other'}
    ];

    @observable toOptions = [
        { label: 'My villa', value: 'My villa'},
        { label: 'Reception', value: 'Reception'},
        { label: 'Wellness Pavilion', value: 'Wellness Pavilion'},
        { label: 'Market restaurant', value: 'Market restaurant'},
        { label: 'Devarana Spa', value: 'Devarana Spa'},
        { label: 'Seagrill restaurant', value: 'Seagrill restaurant'},
        { label: 'Sandbar', value: 'Sandbar'},
        { label: 'Benjarong restaurant', value: 'Benjarong restaurant'},
        { label: 'Sala Bar', value: 'Sala Bar'},
        { label: 'Tennis court', value: 'Tennis court'},
        { label: 'Dive Center', value: 'Dive Center'},
        { label: 'Activity Center', value: 'Activity Center'},
        { label: 'Gym', value: 'Gym'},
        { label: 'Kids Club', value: 'Kids Club'},
        { label: 'Clinic', value: 'Clinic'},
        { label: 'Boutique Shop', value: 'Boutique Shop'},
        { label: 'Other', value: 'Other'}
    ];

    @observable fromOption = this.fromOptions[0].value;
    @observable toOption = this.toOptions[1].value;

    @observable carTypeOption = 'Sedan';

    @observable menu = null;

    // Initialization

    @action initBookTaxiConfirm() {
        this.destination = '';
        this.noOfPerson = 1;

        this.initDateTimeDeliver();

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getTransportation(languageCode).then(resp => {
            return this.menu = resp;
        });
    }

    initDateTimeDeliver() {
        const now = moment();
        this.dateDeliver = now.format('D/M/yyyy');
        this.dateDeliverDate = now.toDate();
        this.timeDeliver = '';
        this.minDate = moment().toDate();
    }

    // Set Properties

    @action setDestination(value) {
        this.destination = value;
    }

    @action setNoOfPerson(value) {
        this.noOfPerson = value;
    }

    @action setCarTypeOption(value) {
        this.carTypeOption = value;
    }

    @action setDateDeliver(value) {
        var selectedDate = moment(value).format('D/M/yyyy');
        this.dateDeliver = selectedDate;
        this.timeDeliver = '';
        this.timeDeliverDate = '';
    }
    
    @action setDateDeliverDate(value) {
        this.dateDeliverDate = value;
        var selectedDate = moment(value).format('D/M/yyyy');
        var currentDate = moment().format('D/M/yyyy');

        if (selectedDate === currentDate) {
            this.minDate = moment().toDate();
        } else {
            let minDate = moment().toDate();
            minDate.setHours(0);
            minDate.setMinutes(0);
            this.minDate = minDate;
        }

        this.timeDeliverDate = this.minDate;
    }

    @action setTimeDeliver(value) {
        this.timeDeliver = value;
    }

    @action setTimeDeliverDate(value) {
        this.timeDeliverDate = value;
    }

    @action setfromOption(value) {
      this.fromOption = value;
    }

    @action settoOption(value) {
      this.toOption = value;
    }

    @action resetData() {
        this.menu = null;
    }
}

export default new bookTaxiStore()